// extracted by mini-css-extract-plugin
module.exports = {"cookie":"Cookies-module--cookie--2ydR3","cookie__buttons-wrapper":"Cookies-module--cookie__buttons-wrapper--2qllb"};